export enum Layout {
    Center,
    SideBySide
}

export enum GameType {
    Survival,
    Time
}

export enum PlayingMode {
    Solo,
    Versus2P,
    Online
}